import { Theme, createStyles, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) => createStyles({
    noUpcomingEvents: {
        textAlign: "center",
        paddingTop: 150,
        paddingBottom: 150,
    }
}));
